import { useEffect, useState } from 'react';
import logo2s from 'assets/img/icons/slogo2.png';
import logodark2s from 'assets/img/icons/slogo-white2.png';
import logo2servi from 'assets/img/icons/servilogo2.png';
import logodark2servi from 'assets/img/icons/servilogo-white2.png';
import logo2 from 'assets/img/icons/logo2.png';
import logodark2 from 'assets/img/icons/logo-white2.png';
import logo2pfs from 'assets/img/icons/pfslogo.png';
import logodark2pfs from 'assets/img/icons/pfslogo-white.png';
import logoke from 'assets/img/icons/kelogo.png';
import logokedark from 'assets/img/icons/kelogo-white.png';
import logoproa from 'assets/img/icons/proaproptechlogo.png';
import logoproadark from 'assets/img/icons/proaproptechlogo-white.png';
import logosirec from 'assets/img/icons/logo2sirec.png';
import logosirecdark from 'assets/img/icons/logo-white2sirec.png';
import logoaurea from 'assets/img/icons/logo2aurea.png';
import logoaureadark from 'assets/img/icons/logo-white2aurea.png';
import logoubimia from 'assets/img/icons/logoubimia2.png';
import logoubimiadark from 'assets/img/icons/logo-whiteubimia2.png';
import classNames from 'classnames';

interface LogoProps {
  width?: number;
  className?: string;
}

const Logo2 = ({ width = 160, className }: LogoProps) => {
  const companyName = import.meta.env.VITE_COMPANYNAME || 'Default';
  const [selectedLogo, setSelectedLogo] = useState<string>(logo2);
  const [selectedLogoDark, setSelectedLogoDark] = useState<string>(logodark2);

  useEffect(() => {
    // Seleccionar los logotipos adecuados basados en el nombre de la compañía
    if (companyName === 'Serodi') {
      setSelectedLogo(logo2s);
      setSelectedLogoDark(logodark2s);
    } else if (companyName === 'Servinform') {
      setSelectedLogo(logo2servi);
      setSelectedLogoDark(logodark2servi);
    } else if (companyName === 'PFS') {
      setSelectedLogo(logo2pfs);
      setSelectedLogoDark(logodark2pfs);
    } else if (companyName === 'Keldai') {
      setSelectedLogo(logoke);
      setSelectedLogoDark(logokedark);
    } else if (companyName === 'ProaProptech') {
      setSelectedLogo(logoproa);
      setSelectedLogoDark(logoproadark);
    } else if (companyName === 'SIREC') {
      setSelectedLogo(logosirec);
      setSelectedLogoDark(logosirecdark);
    } else if (companyName === 'Aurea') {
      setSelectedLogo(logoaurea);
      setSelectedLogoDark(logoaureadark);
    } else if (companyName === 'ubimia') {
      setSelectedLogo(logoubimia);
      setSelectedLogoDark(logoubimiadark);
    } else {
      setSelectedLogo(logo2);
      setSelectedLogoDark(logodark2);
    }
  }, [companyName]);

  return (
    <div className={classNames(className, 'd-flex align-items-center')}>
      <img
        src={selectedLogo}
        alt={`${companyName} Logo`}
        width={width}
        className="d-dark-none"
      />
      <img
        src={selectedLogoDark}
        alt={`${companyName} Logo Dark`}
        width={width}
        className="d-light-none"
      />
    </div>
  );
};

export default Logo2;
